import { PDFViewer } from '@react-pdf/renderer';
import React, { useMemo } from 'react';

import { usePackage } from '../packageProvider';
import { useShipping } from '../shippingProvider';
import PDFPreviewPage from './pdfPreviewPage';

export default function PDFPreview() {
  const {
    order,
    packages,
    totalPkgNum,
    shipDate,
    shipMethod,
    handleGetQuoteNum,
    currentPkgNum,
    qboEstimateDoc,
  } = usePackage();
  const { toAddress } = useShipping();

  const { selectedItems: renderItems, quoteNum: stripeQuoteNumber } = useMemo(() => {
    if (!packages?.length || !currentPkgNum) return { selectedItems: [], quoteNum: '' };
    const pkg = packages[currentPkgNum - 1];
    const selectedItems = pkg.lineItems.filter((item) => item.isChecked);
    const quoteNum = handleGetQuoteNum(selectedItems);
    return {
      selectedItems,
      quoteNum,
    };
  }, [packages, currentPkgNum, handleGetQuoteNum]);

  if (!totalPkgNum || !currentPkgNum) {
    return <div>No Preview Available</div>;
  }

  return (
    <PDFViewer width="100%" height="100%" showToolbar={false} style={{ border: 0 }}>
      <PDFPreviewPage
        order={order}
        toAddress={toAddress}
        renderItems={renderItems}
        currentPkgNum={currentPkgNum}
        totalPkgNum={totalPkgNum}
        shipDate={shipDate}
        shipMethod={shipMethod}
        stripeQuoteNumber={stripeQuoteNumber}
        qboEstimateNumber={qboEstimateDoc}
      />
    </PDFViewer>
  );
}
